
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhatWeDoSection from './components/WhatWeDoSection';
import IndustriesSection from './components/IndustriesSection';
import AddOnServicesSection from './components/AddOnServicesSection';
import TestimonialSection from './components/TestimonialSection';
import FinalCTASection from './components/FinalCTASection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <WhatWeDoSection />
        <IndustriesSection />
        <AddOnServicesSection />
        <TestimonialSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
